module.exports = __webpack_public_path__ + "b828c16229fe215e30823e59101e6520.svg";